import type React from 'react';

import {
    Button,
    Description,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    DialogRoot,
    Heading,
    LoadingIndicator,
} from '@gitbook/spine-react';

import type { ImportModalProps } from './types';

export function ImportModalFrame(
    props: Omit<ImportModalProps, 'startImport'> & {
        children: React.ReactNode;
        onSubmit: () => void;
        cannotSubmit: boolean;
        isLoading: boolean;
    }
): React.ReactElement {
    const { title, subtitle, onClose, onSubmit, children, cannotSubmit, isLoading } = props;

    return (
        <DialogRoot
            isOpen
            onOpenChange={(isOpen) => {
                if (!isOpen) {
                    onClose();
                }
            }}
        >
            <Dialog>
                <DialogHeader>
                    <Heading>{title}</Heading>
                    <Description>{subtitle}</Description>
                </DialogHeader>
                <DialogBody>{children}</DialogBody>
                <DialogFooter>
                    <div className="flex justify-end gap-2">
                        <Button
                            type="button"
                            label="Back"
                            kind="secondary"
                            onPress={onClose}
                            disabled={isLoading}
                        />
                        <Button
                            label="Start import"
                            kind="primary"
                            onPress={onSubmit}
                            disabled={cannotSubmit || isLoading}
                            leadingIcon={isLoading ? <LoadingIndicator /> : undefined}
                        />
                    </div>
                </DialogFooter>
            </Dialog>
        </DialogRoot>
    );
}
